import { PALETTE } from '../StageData';
import { ShadingPipeline } from '../../engine/ShadingPipeline';
import type { ShapeDrawFn } from './furnitureShapes';

export const animalDrawFns: Record<number, ShapeDrawFn> = {
  // STAGE 71: テディベア
  71: (ctx, cx, cy, mode) => {
    const drawBear = () => {
      ctx.beginPath();
      ctx.arc(cx - 55, cy - 95, 25, 0, Math.PI * 2);
      ctx.arc(cx + 55, cy - 95, 25, 0, Math.PI * 2);
      ctx.arc(cx, cy - 50, 65, 0, Math.PI * 2);
      ctx.arc(cx, cy + 65, 85, 0, Math.PI * 2);
    };

    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5'; drawBear(); ctx.fill();
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        drawBear(); ctx.stroke();
        ctx.strokeRect(cx - 30, cy + 5, 60, 20);
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy, 170, 240, PALETTE.wood, 'cloth');
      drawBear(); ctx.fill();
      ctx.fillStyle = PALETTE.crimson; ctx.fillRect(cx - 30, cy + 5, 60, 20);
      ctx.fillStyle = PALETTE.black;
      ctx.beginPath(); ctx.arc(cx - 22, cy - 55, 6, 0, Math.PI * 2); ctx.fill();
      ctx.beginPath(); ctx.arc(cx + 22, cy - 55, 6, 0, Math.PI * 2); ctx.fill();
      ShadingPipeline.renderSpecularGlint(ctx, cx - 25, cy - 70, 25, 20, 0.35);
    }
  },

  // STAGE 72: ラバーダック
  72: (ctx, cx, cy, mode) => {
    const drawDuck = () => {
      ctx.beginPath();
      ctx.ellipse(cx - 10, cy + 50, 85, 65, 0, 0, Math.PI * 2);
      ctx.arc(cx - 30, cy - 45, 50, 0, Math.PI * 2);
      ctx.lineTo(cx + 85, cy + 10);
      ctx.closePath();
    };

    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5'; drawDuck(); ctx.fill();
      ctx.fillStyle = '#FAF8F5';
      ctx.beginPath(); ctx.ellipse(cx - 85, cy - 35, 28, 14, 0, 0, Math.PI * 2); ctx.fill();
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        drawDuck(); ctx.stroke();
        ctx.beginPath(); ctx.ellipse(cx - 85, cy - 35, 28, 14, 0, 0, Math.PI * 2); ctx.stroke();
        ctx.beginPath(); ctx.arc(cx - 45, cy - 55, 6, 0, Math.PI * 2); ctx.stroke();
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy, 180, 180, PALETTE.yellow, 'lacquer');
      drawDuck(); ctx.fill();
      ctx.fillStyle = PALETTE.orange;
      ctx.beginPath(); ctx.ellipse(cx - 85, cy - 35, 28, 14, 0, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = PALETTE.black;
      ctx.beginPath(); ctx.arc(cx - 45, cy - 55, 6, 0, Math.PI * 2); ctx.fill();
      ShadingPipeline.renderSpecularGlint(ctx, cx - 45, cy - 65, 25, 18, 0.6);
    }
  },

  // STAGE 73: 木彫りフクロウ
  73: (ctx, cx, cy, mode) => {
    const drawOwl = () => {
      ctx.beginPath();
      ctx.ellipse(cx, cy + 10, 85, 120, 0, 0, Math.PI * 2);
      ctx.moveTo(cx - 60, cy - 100); ctx.lineTo(cx - 40, cy - 150); ctx.lineTo(cx - 20, cy - 100);
      ctx.moveTo(cx + 20, cy - 100); ctx.lineTo(cx + 40, cy - 150); ctx.lineTo(cx + 60, cy - 100);
    };

    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5'; drawOwl(); ctx.fill();
      ctx.fillStyle = '#FAF8F5';
      ctx.beginPath(); ctx.arc(cx - 32, cy - 45, 26, 0, Math.PI * 2); ctx.fill();
      ctx.beginPath(); ctx.arc(cx + 32, cy - 45, 26, 0, Math.PI * 2); ctx.fill();
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        drawOwl(); ctx.stroke();
        ctx.beginPath(); ctx.arc(cx - 32, cy - 45, 26, 0, Math.PI * 2); ctx.stroke();
        ctx.beginPath(); ctx.arc(cx + 32, cy - 45, 26, 0, Math.PI * 2); ctx.stroke();
        ctx.beginPath(); ctx.moveTo(cx, cy - 30); ctx.lineTo(cx + 12, cy - 10); ctx.lineTo(cx - 12, cy - 10); ctx.closePath(); ctx.stroke();
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy + 10, 170, 240, PALETTE.darkWood, 'wood');
      drawOwl(); ctx.fill();
      ctx.fillStyle = PALETTE.gold;
      ctx.beginPath(); ctx.arc(cx - 32, cy - 45, 26, 0, Math.PI * 2); ctx.fill();
      ctx.beginPath(); ctx.arc(cx + 32, cy - 45, 26, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = PALETTE.ivory;
      ctx.beginPath(); ctx.ellipse(cx, cy + 40, 45, 60, 0, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = PALETTE.black;
      ctx.beginPath(); ctx.arc(cx - 32, cy - 45, 10, 0, Math.PI * 2); ctx.fill();
      ctx.beginPath(); ctx.arc(cx + 32, cy - 45, 10, 0, Math.PI * 2); ctx.fill();
    }
  },

  // STAGE 74: 木製キリン
  74: (ctx, cx, cy, mode) => {
    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5';
      ctx.beginPath();
      ctx.moveTo(cx - 35, cy + 90); ctx.lineTo(cx - 15, cy - 150); ctx.lineTo(cx + 40, cy - 150); ctx.lineTo(cx + 15, cy + 90); ctx.closePath(); ctx.fill();
      ctx.beginPath(); ctx.ellipse(cx + 40, cy + 90, 75, 45, 0, 0, Math.PI * 2); ctx.fill();
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        ctx.beginPath();
        ctx.moveTo(cx - 35, cy + 90); ctx.lineTo(cx - 15, cy - 150); ctx.lineTo(cx + 40, cy - 150); ctx.lineTo(cx + 15, cy + 90); ctx.closePath();
        ctx.stroke();
        ctx.beginPath(); ctx.ellipse(cx + 40, cy + 90, 75, 45, 0, 0, Math.PI * 2); ctx.stroke();
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy, 160, 270, PALETTE.yellow, 'wood');
      ctx.beginPath();
      ctx.moveTo(cx - 35, cy + 90); ctx.lineTo(cx - 15, cy - 150); ctx.lineTo(cx + 40, cy - 150); ctx.lineTo(cx + 15, cy + 90); ctx.closePath(); ctx.fill();
      ctx.beginPath(); ctx.ellipse(cx + 40, cy + 90, 75, 45, 0, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = PALETTE.darkWood;
      for (let i = 0; i < 4; i++) {
        ctx.beginPath(); ctx.arc(cx - 8, cy - 100 + i * 45, 14, 0, Math.PI * 2); ctx.fill();
      }
    }
  },

  // STAGE 75: ジャイアントパンダ
  75: (ctx, cx, cy, mode) => {
    const drawPandaHead = () => {
      ctx.beginPath(); ctx.ellipse(cx, cy, 95, 80, 0, 0, Math.PI * 2);
    };

    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5';
      ctx.beginPath(); ctx.arc(cx - 70, cy - 75, 30, 0, Math.PI * 2); ctx.fill();
      ctx.beginPath(); ctx.arc(cx + 70, cy - 75, 30, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = '#FAF8F5'; drawPandaHead(); ctx.fill();
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        ctx.beginPath(); ctx.arc(cx - 70, cy - 75, 30, 0, Math.PI * 2); ctx.stroke();
        ctx.beginPath(); ctx.arc(cx + 70, cy - 75, 30, 0, Math.PI * 2); ctx.stroke();
        drawPandaHead(); ctx.stroke();
        ctx.beginPath(); ctx.ellipse(cx - 35, cy - 10, 22, 28, -0.2, 0, Math.PI * 2); ctx.stroke();
        ctx.beginPath(); ctx.ellipse(cx + 35, cy - 10, 22, 28, 0.2, 0, Math.PI * 2); ctx.stroke();
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = PALETTE.black;
      ctx.beginPath(); ctx.arc(cx - 70, cy - 75, 30, 0, Math.PI * 2); ctx.fill();
      ctx.beginPath(); ctx.arc(cx + 70, cy - 75, 30, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy, 190, 160, PALETTE.white, 'cloth');
      drawPandaHead(); ctx.fill();
      ctx.fillStyle = PALETTE.black;
      ctx.beginPath(); ctx.ellipse(cx - 35, cy - 10, 22, 28, -0.2, 0, Math.PI * 2); ctx.fill();
      ctx.beginPath(); ctx.ellipse(cx + 35, cy - 10, 22, 28, 0.2, 0, Math.PI * 2); ctx.fill();
      ctx.beginPath(); ctx.arc(cx, cy + 25, 12, 0, Math.PI * 2); ctx.fill();
    }
  },

  // STAGE 76: シロナガスクジラ
  76: (ctx, cx, cy, mode) => {
    const drawWhale = () => {
      ctx.beginPath();
      ctx.moveTo(cx - 140, cy);
      ctx.bezierCurveTo(cx - 100, cy - 80, cx + 50, cy - 60, cx + 110, cy - 20);
      ctx.lineTo(cx + 150, cy - 45);
      ctx.lineTo(cx + 135, cy);
      ctx.lineTo(cx + 150, cy + 45);
      ctx.bezierCurveTo(cx + 50, cy + 60, cx - 80, cy + 70, cx - 140, cy);
      ctx.closePath();
    };

    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5'; drawWhale(); ctx.fill();
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        drawWhale(); ctx.stroke();
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy, 290, 130, PALETTE.deepBlue, 'lacquer');
      drawWhale(); ctx.fill();
      ctx.fillStyle = PALETTE.white;
      ctx.beginPath();
      ctx.moveTo(cx - 130, cy + 5);
      ctx.bezierCurveTo(cx - 70, cy + 55, cx + 40, cy + 45, cx + 90, cy + 10);
      ctx.closePath(); ctx.fill();
      ctx.fillStyle = PALETTE.cyan;
      ctx.beginPath(); ctx.arc(cx - 40, cy - 80, 16, 0, Math.PI * 2); ctx.fill();
      ShadingPipeline.renderSpecularGlint(ctx, cx - 40, cy - 30, 45, 15, 0.55);
    }
  },

  // STAGE 77: モルフォ蝶レリーフ
  77: (ctx, cx, cy, mode) => {
    const drawButterflyWings = () => {
      ctx.beginPath();
      ctx.moveTo(cx, cy);
      ctx.bezierCurveTo(cx - 60, cy - 140, cx - 140, cy - 110, cx - 130, cy - 20);
      ctx.bezierCurveTo(cx - 140, cy + 60, cx - 60, cy + 120, cx, cy + 40);
      ctx.closePath();
      ctx.moveTo(cx, cy);
      ctx.bezierCurveTo(cx + 60, cy - 140, cx + 140, cy - 110, cx + 130, cy - 20);
      ctx.bezierCurveTo(cx + 140, cy + 60, cx + 60, cy + 120, cx, cy + 40);
      ctx.closePath();
    };

    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5'; drawButterflyWings(); ctx.fill();
      ctx.fillStyle = '#FAF8F5'; ctx.fillRect(cx - 6, cy - 80, 12, 140);
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        drawButterflyWings(); ctx.stroke();
        ctx.strokeRect(cx - 6, cy - 80, 12, 140);
      });
    } else if (mode === 'targetPreview') {
      const grad = ctx.createRadialGradient(cx, cy, 20, cx, cy, 140);
      grad.addColorStop(0, PALETTE.cyan);
      grad.addColorStop(0.7, PALETTE.purple);
      grad.addColorStop(1, PALETTE.black);
      ctx.fillStyle = grad; drawButterflyWings(); ctx.fill();
      ctx.fillStyle = PALETTE.black; ctx.fillRect(cx - 6, cy - 80, 12, 140);
      ShadingPipeline.renderSpecularGlint(ctx, cx - 60, cy - 50, 35, 35, 0.65);
      ShadingPipeline.renderSpecularGlint(ctx, cx + 60, cy - 50, 35, 35, 0.65);
    }
  },

  // STAGE 78: ティラノサウルス
  78: (ctx, cx, cy, mode) => {
    const drawTRexSkull = () => {
      ctx.beginPath();
      ctx.moveTo(cx - 130, cy - 40);
      ctx.lineTo(cx + 70, cy - 80);
      ctx.lineTo(cx + 110, cy + 40);
      ctx.lineTo(cx + 40, cy + 70);
      ctx.lineTo(cx - 90, cy + 40);
      ctx.closePath();
    };

    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5'; drawTRexSkull(); ctx.fill();
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        drawTRexSkull(); ctx.stroke();
        ctx.beginPath(); ctx.arc(cx + 30, cy - 30, 18, 0, Math.PI * 2); ctx.stroke();
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy, 240, 150, PALETTE.forest, 'ceramic');
      drawTRexSkull(); ctx.fill();
      ctx.fillStyle = PALETTE.gold;
      ctx.beginPath(); ctx.arc(cx + 30, cy - 30, 18, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = PALETTE.crimson;
      for (let i = 0; i < 5; i++) {
        ctx.fillRect(cx - 100 + i * 28, cy + 15, 8, 16);
      }
      ShadingPipeline.renderSpecularGlint(ctx, cx - 40, cy - 50, 35, 15, 0.45);
    }
  },

  // STAGE 79: 皇帝ペンギン
  79: (ctx, cx, cy, mode) => {
    const drawPenguin = () => {
      ctx.beginPath(); ctx.ellipse(cx, cy + 20, 85, 130, 0, 0, Math.PI * 2);
    };

    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5'; drawPenguin(); ctx.fill();
      ctx.fillStyle = '#FAF8F5';
      ctx.beginPath(); ctx.ellipse(cx, cy + 30, 55, 100, 0, 0, Math.PI * 2); ctx.fill();
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        drawPenguin(); ctx.stroke();
        ctx.beginPath(); ctx.ellipse(cx, cy + 30, 55, 100, 0, 0, Math.PI * 2); ctx.stroke();
        ctx.beginPath(); ctx.moveTo(cx, cy - 90); ctx.lineTo(cx - 30, cy - 75); ctx.lineTo(cx, cy - 60); ctx.stroke();
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy + 20, 170, 260, PALETTE.black, 'cloth');
      drawPenguin(); ctx.fill();
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy + 30, 110, 200, PALETTE.white, 'cloth');
      ctx.beginPath(); ctx.ellipse(cx, cy + 30, 55, 100, 0, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = PALETTE.gold;
      ctx.beginPath(); ctx.ellipse(cx - 45, cy - 60, 18, 30, -0.4, 0, Math.PI * 2); ctx.fill();
      ctx.beginPath(); ctx.ellipse(cx + 45, cy - 60, 18, 30, 0.4, 0, Math.PI * 2); ctx.fill();
      ShadingPipeline.renderSpecularGlint(ctx, cx - 25, cy - 65, 20, 30, 0.4);
    }
  },

  // STAGE 80: アマガエルトイ
  80: (ctx, cx, cy, mode) => {
    const drawFrog = () => {
      ctx.beginPath();
      ctx.ellipse(cx, cy + 20, 110, 85, 0, 0, Math.PI * 2);
      ctx.arc(cx - 65, cy - 60, 35, 0, Math.PI * 2);
      ctx.arc(cx + 65, cy - 60, 35, 0, Math.PI * 2);
    };

    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5'; drawFrog(); ctx.fill();
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        drawFrog(); ctx.stroke();
        ctx.beginPath(); ctx.arc(cx - 65, cy - 60, 16, 0, Math.PI * 2); ctx.stroke();
        ctx.beginPath(); ctx.arc(cx + 65, cy - 60, 16, 0, Math.PI * 2); ctx.stroke();
        ctx.beginPath(); ctx.arc(cx, cy + 20, 55, 0.2 * Math.PI, 0.8 * Math.PI); ctx.stroke();
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy, 220, 170, PALETTE.emerald, 'lacquer');
      drawFrog(); ctx.fill();
      ctx.fillStyle = PALETTE.yellow;
      ctx.beginPath(); ctx.ellipse(cx, cy + 35, 65, 45, 0, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = PALETTE.crimson;
      ctx.beginPath(); ctx.arc(cx - 65, cy - 60, 14, 0, Math.PI * 2); ctx.fill();
      ctx.beginPath(); ctx.arc(cx + 65, cy - 60, 14, 0, Math.PI * 2); ctx.fill();
      ShadingPipeline.renderSpecularGlint(ctx, cx - 75, cy - 75, 12, 12, 0.65);
      ShadingPipeline.renderSpecularGlint(ctx, cx + 55, cy - 75, 12, 12, 0.65);
    }
  }
};
